import React from "react";
import Table from "./table";
import { CardApplicationProps } from "./types";

export default function DashboardCardholderApplication({
  cardholderApplications,
}: CardApplicationProps): React.JSX.Element {
  return <Table cardholderApplications={cardholderApplications} />;
}
